// extracted by mini-css-extract-plugin
module.exports = {"root":"DeleteUserForm_root__3Ox_J","sectionTitle":"DeleteUserForm_sectionTitle__3Kpnh","submitButton":"DeleteUserForm_submitButton__2hT6p"};